import { render, staticRenderFns } from "./ecnprojectuser.vue?vue&type=template&id=3fb2a677&scoped=true&"
import script from "./ecnprojectuser.vue?vue&type=script&lang=js&"
export * from "./ecnprojectuser.vue?vue&type=script&lang=js&"
import style0 from "./ecnprojectuser.vue?vue&type=style&index=0&id=3fb2a677&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb2a677",
  null
  
)

export default component.exports